module.exports = __webpack_public_path__ + "img/white.ebad18d3.png";